module.exports = __webpack_public_path__ + "static/media/about-us.f00a57a6.png";